
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 238.37 238.37"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M119.18 92A27.24 27.24 0 1192 119.18 27.27 27.27 0 01119.18 92m0-8.65a35.89 35.89 0 1035.89 35.88 35.89 35.89 0 00-35.89-35.93z"}}),_c('path',{attrs:{"d":"M119.18 13.3a105.88 105.88 0 0174.87 180.75A105.88 105.88 0 1144.32 44.32a105.16 105.16 0 0174.86-31m0-8.64a114.53 114.53 0 10114.53 114.5A114.52 114.52 0 00119.18 4.66z"}})])
          )
        }
      }
    